import { Box, useDisclosure } from '@chakra-ui/react';
import Unverified from './Unverified';
import Submitted from './Submitted';
import { OnBoardingModal } from '@/components/common/OnBoarding';
import { useEffect, useState } from 'react';
import withAuth from '@/HOCs/withAuth';
import { useStore } from '@/store/store';
import Rejected from './Rejected';
import Dashboard from '../Dashboard';

const Home = () => {
  const { onOpen, onClose } = useDisclosure();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [modalShownInSession, setModalShownInSession] = useState(false);
  const { user } = useStore();

  useEffect(() => {
    const onboardingCompleted = sessionStorage.getItem('onboardingCompleted');

    // Show modal only if:
    // 1. The user is unverified
    // 2. The onboarding is not completed
    // 3. The modal hasn't already been shown in this session
    if (
      user?.vendor_status?.status === 'unverified' &&
      onboardingCompleted !== 'true' &&
      !modalShownInSession
    ) {
      setShowOnboarding(true);
      setModalShownInSession(true);
      onOpen();
    }
  }, [user?.vendor_status?.status, modalShownInSession, onOpen]);

  const handleOnboardingClose = (completed: boolean) => {
    if (completed || modalShownInSession === true) {
      sessionStorage.setItem('onboardingCompleted', 'true');
    }
    setShowOnboarding(false);
    onClose();
  };

  const renderComponentByStatus = () => {
    switch (user?.vendor_status?.status) {
      case 'unverified':
        return (
          <Unverified
            onOpen={onOpen}
            setModalShownInSession={setModalShownInSession}
            setShowOnBoarding={setShowOnboarding}
          />
        );
      case 'pending':
        return <Submitted />;
      case 'rejected':
        return (
          <Rejected
            onOpen={onOpen}
            setModalShownInSession={setModalShownInSession}
            setShowOnBoarding={setShowOnboarding}
          />
        );
      default:
        return (
          <Box width={'100%'} height={'100%'}>
            <Dashboard />
          </Box>
        );
    }
  };

  return (
    <>
      <Box
        fontFamily={'primary'}
        height={'100%'}
        width={'100%'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        {renderComponentByStatus()}
      </Box>
      {user && (
        <OnBoardingModal
          isOpen={showOnboarding}
          onClose={() => handleOnboardingClose(false)}
          onComplete={() => handleOnboardingClose(true)}
          user={user}
        />
      )}
    </>
  );
};

export default withAuth(Home);
